// import getTable from "./../../../datamock/getTable/getTable";
// import getDetailContent from "./../../../datamock/getDetailContent/getDetailContent";
// import lodash from "lodash";
import baseUrl from "./../../util/backend";
import axios from "axios";
export default {
  ///getTable//////
  // NOTE getข้องมูลtable
  async getTable({ commit, state, rootGetters }, payload) {
    try {
      // console.log(this.$route.path);
      // console.log("id_user nana", state.id_user);
      if (payload === "second") {
        const response = await axios.get(
          // `${baseUrl}/admin/getTable?path=${payload}&id_user=${state.id_user}`
          `${baseUrl}/admin/getTable?path=${payload}&detail_id=${rootGetters["create/getCompanyName"].id}`,
          {
            headers: {
              Authorization: rootGetters.getToken,
            },
          }
        );
        commit("GET_TABLE", response.data.data);
      } else {
        const response = await axios.get(
          // `${baseUrl}/admin/getTable?path=${payload}&id_user=${state.id_user}`
          `${baseUrl}/admin/getTable?path=${payload}`,
          {
            headers: {
              Authorization: rootGetters.getToken,
            },
          }
        );
        commit("GET_TABLE", response.data.data);
      }
      // console.log("table", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async getExportTask({ commit, state, rootGetters }, payload) {
    console.log("rak dek ");
    try {
      const response = await axios.get(`${baseUrl}/admin/getTable`, {
        headers: {
          Authorization: rootGetters.getToken,
        },
        params: {
          path: "exportTask",
          from: payload.from,
          to: payload.to,
        },
      });
      commit("GET_TABLE", response.data.data);
      // console.log("table", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async getFilteredTaskTable({ commit, state, rootGetters }, payload) {
    try {
      // console.log(this.$route.path);
      // console.log("id_user nana", state.id_user);
      if (rootGetters["create/getCompanyName"]) {
        if (payload.year === "ALL") {
          const response = await axios.get(
            // `${baseUrl}/admin/getTable?path=${payload}&id_user=${state.id_user}`
            `${baseUrl}/admin/getTable?path=${payload.path}&detail_id=${rootGetters["create/getCompanyName"].id}`,
            {
              headers: {
                Authorization: rootGetters.getToken,
              },
            }
          );
          commit("GET_TABLE", response.data.data);
        } else {
          const response = await axios.get(
            // `${baseUrl}/admin/getTable?path=${payload}&id_user=${state.id_user}`
            `${baseUrl}/admin/getTable?path=${payload.path}&detail_id=${rootGetters["create/getCompanyName"].id}&month_service=${payload.month}&year_service=${payload.year}`,
            {
              headers: {
                Authorization: rootGetters.getToken,
              },
            }
          );
          commit("GET_TABLE", response.data.data);
        }
      } else {
        const response = await axios.get(
          `${baseUrl}/admin/getTable?path=${payload}&id_user=${state.id_user}`,
          {
            headers: {
              Authorization: rootGetters.getToken,
            },
          }
          // `${baseUrl}/admin/getTable?path=${payload}&detail_id=${rootGetters["create/getCompanyName"].id}`
        );
        commit("GET_TABLE", response.data.data);
      }
      // console.log("table", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async getFilteredInvoiceTable({ commit, state, rootGetters }, payload) {
    console.log("payload-path", payload.path);
    try {
      if (payload.startDate && payload.endDate && payload.status) {
        const response = await axios.get(
          // `${baseUrl}/admin/getTable?path=${payload}&id_user=${state.id_user}`
          `${baseUrl}/admin/getTable?path=${payload.path}&start_date=${payload.startDate}&end_date=${payload.endDate}&status=${payload.status}`,
          {
            headers: {
              Authorization: rootGetters.getToken,
            },
          }
        );
        commit("GET_TABLE", response.data.data);
      } else if (payload.startDate && payload.endDate && !payload.status) {
        const response = await axios.get(
          // `${baseUrl}/admin/getTable?path=${payload}&id_user=${state.id_user}`
          `${baseUrl}/admin/getTable?path=${payload.path}&start_date=${payload.startDate}&end_date=${payload.endDate}`,
          {
            headers: {
              Authorization: rootGetters.getToken,
            },
          }
        );
        commit("GET_TABLE", response.data.data);
      } else if (payload.status) {
        const response = await axios.get(
          `${baseUrl}/admin/getTable?path=${payload.path}&status=${payload.status}`,
          {
            headers: {
              Authorization: rootGetters.getToken,
            },
          }
        );
        commit("GET_TABLE", response.data.data);
      } else {
        const response = await axios.get(
          // `${baseUrl}/admin/getTable?path=${payload}&id_user=${state.id_user}`
          `${baseUrl}/admin/getTable?path=${payload.path}`,
          {
            headers: {
              Authorization: rootGetters.getToken,
            },
          }
        );
        commit("GET_TABLE", response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  },
  async getMemberTable({ commit, state, rootGetters }, payload) {
    const response = await axios.get(
      // `${baseUrl}/admin/getTable?path=${payload}&id_user=${state.id_user}`
      `${baseUrl}/admin/getTable?path=${payload.path}&role_id=${payload.roleId}`,
      {
        headers: {
          Authorization: rootGetters.getToken,
        },
      }
    );
    commit("GET_TABLE", response.data.data);
  },
  async getFilteredFolderTable({ commit, state, rootGetters }, payload) {
    const response = await axios.get(
      // `${baseUrl}/admin/getTable?path=${payload}&id_user=${state.id_user}`
      `${baseUrl}/admin/getTable?path=${payload.path}&folder_id=${payload.folderId}&user_id=${payload.userId}`,
      {
        headers: {
          Authorization: rootGetters.getToken,
        },
      }
    );
    commit("GET_TABLE", response.data.data);
  },
  async getFilteredAdminTable({ commit, state, rootGetters }, payload) {
    try {
      const response = await axios.get(
        // `${baseUrl}/admin/getTable?path=${payload}&id_user=${state.id_user}`
        `${baseUrl}/admin/getTable?path=${payload.path}&role_id=${payload.roleId}`,
        {
          headers: {
            Authorization: rootGetters.getToken,
          },
        }
      );
      commit("GET_TABLE", response.data.data);
    } catch (error) {
      console.error(error);
    }
  },
  async getFilteredBankTable({ commit, state, rootGetters }, payload) {
    try {
      const response = await axios.get(
        `${baseUrl}/admin/getTable?path=${payload.path}&bank=${payload.bank}`,
        {
          headers: {
            Authorization: rootGetters.getToken,
          },
        }
      );
      commit("GET_TABLE", response.data.data);
    } catch (error) {
      console.error(error);
    }
  },
  async getSubTable({ commit, state, rootGetters }, payload) {
    try {
      let link = "";
      if (payload.year === "ALL") {
        link = `${baseUrl}/admin/getTable?path=${payload.path}&detail_id=${rootGetters["create/getCompanyName"].id}`;
      } else {
        link = `${baseUrl}/admin/getTable?path=${payload.path}&detail_id=${rootGetters["create/getCompanyName"].id}&month_service=${payload.month}&year_service=${payload.year}`;
      }
      const response = await axios.get(
        // `${baseUrl}/admin/getTable?path=${payload}&id_user=${state.id_user}`
        link,
        {
          headers: {
            Authorization: rootGetters.getToken,
          },
        }
      );
      // console.log("table", response.data);
      commit("GET_SUB_TABLE", response.data.data);
    } catch (error) {
      console.error(error);
    }
  },
  async getUserFileTable({ commit, state, rootGetters }, payload) {
    let link = "";
    if (payload.folderId) {
      link = `${baseUrl}/admin/getTable?path=${payload.path}&user_id=${payload.userId}&folder_id=${payload.folderId}`;
    } else {
      link = `${baseUrl}/admin/getTable?path=${payload.path}&user_id=${payload.userId}`;
    }
    try {
      const response = await axios.get(link, {
        headers: {
          Authorization: rootGetters.getToken,
        },
      });
      commit("GET_TABLE", response.data.data);
    } catch (error) {
      console.error(error);
    }
  },
  changeSubTable(context, payload) {
    context.commit("CHANGE_SUB_TABLE", payload);
  },
  ///getTabComponent////
  // NOTE getข้อมูลtab
  async getTab({ commit }, payload) {
    try {
      const response = await axios.get(`${baseUrl}/getTab?path=${payload}`);
      for (const index of response.data.data) {
        if (index.isClick) {
          let active = index;
          console.log(active);
          commit("GET_TAB_ACTIVE", active);
        }
      }
      // console.log(response.data);
      commit("GET_TAB", response.data.data);
    } catch (error) {
      console.error(error);
    }
  },

  ///getRenderDetail
  async getRenderDetail({ commit }, payload) {
    console.log("payload", payload);
    try {
      const response = await axios.get(
        `${baseUrl}/getDetailContent?path=${payload.path}&detail=${payload.detail}&id_user=${payload.id_user}`
      );
      console.log("detail", response.data.data);
      commit("GET_RENDER_DETAIL", response.data.data.componentDetail);
      commit("GET_DETAIL_DATA", response.data.data.data);
    } catch (error) {
      console.error(error);
    }
    // lodash.each(getDetailContent, a => {
    //   // console.log(a);
    //   if (a.slug === `${payload}`) {
    //     console.log("aaa", a);
    //     commit("GET_RENDER_DETAIL", a.componentDetail);
    //     commit("GET_DETAIL_DATA", a.data);
    //   }
    //   // a.slug === payload ? commit("GET_RENDER_DETAIL", a.componentDetail),log : null;
    // });
  },

  ///change tab component active
  async changeTabActive({ commit, state }, payload) {
    for await (const index of state.tab) {
      if (payload.path == index.path) {
        index.isClick = true;
        console.log("index active", index);

        commit("GET_TAB_ACTIVE", index);
      } else {
        index.isClick = false;
      }
    }
    console.log("state.tab", state.tab);
    commit("GET_TAB", state.tab);
  },
};
